/*
 * @Description: 猜你喜欢
 * @Author: ywj
 * @Date: 2025-03-04 17:48:08
 * @LastEditTime: 2025-04-27 11:13:57
 * @LastEditors: ywj@originqc.com
 */
import React,{useEffect,useState} from "react";
import { Carousel } from 'antd';
import Card from '@/components/card'
import { getHappily } from '@/api/list'
import './index.scss';
interface ILikeProps{ 
data:any,
showCount?: number; // 展示个数
}
interface ICarouselProps{ 
  mode?: 'normal' | 'mini'; // 添加 mode 属性,猜你喜欢展示5个商品normal,展示上下2个，用mini，
  showCount?: number; // 展示个数
}
const LikeCarousel: React.FC<ILikeProps> = (props) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 5,
    slidesToShow: 5,
    autoplay: true
  };

  const { data } = props;

  return <div className="like-carousel-container">
    <div className="line-box">
            <div className="line"></div>
            <span className='line-text'>产品推荐</span>
            <div className="line"></div>
          </div>
          <div className="recommend-box">
            <Carousel   {...settings}>
              {data?.length > 0 && data?.map((item: any) => (
                <div key={item.id} className="recommend-card-box">
                  <Card {...item} width={234} is_list="like" />
                </div>
              ))}
            </Carousel >
          </div>
   
  </div>;
}

const LikeCarouselMini: React.FC<ILikeProps> = (props) => { 
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 1,
    autoplay: true
  };

  const { data, showCount } = props;
  const getCount = showCount ?? 3;
  // 这里假设将数据分成每组 2 个元素，以实现垂直排列
const groupedData = [];
for (let i = 0; i < data.length; i += getCount) {
  groupedData.push(data.slice(i, i + getCount));
}
  return <div className="like-carousel-main">
    <div className="line-box"> 
      <span className='line-text'>产品推荐</span>
    </div>
      <div className="recommend-box">
      <Carousel {...settings}>
        {groupedData.map((group, groupIndex) => (
          <div key={groupIndex} className="recommend-group">
            {group.map((item: any) => (
              <div key={item.id} className="recommend-card-box like-card">
                <Card {...item} width={234} height={221} is_list="like" is_title="true" />
              </div>
            ))}
          </div>
        ))}
      </Carousel>
    </div>
  </div>;
}
const CarouselComponent: React.FC<ICarouselProps> = (props) => { 
  const [happyData, setHappyData] = useState<any>([]); //猜你喜欢
  const [likeLoading, setLikeLoading] = useState(true);
  const { mode='normal', showCount } = props;
  useEffect(() => {
    handleHappily();
  }, [])
  const handleHappily = async () => {
    try {
      const res = await getHappily();
      setHappyData(res.obj);
      setLikeLoading(false);
    } catch (error) {
      console.log(error);
      setLikeLoading(false);
    } finally {
      setLikeLoading(false);
    }
  };
  return (
    <React.Fragment>
      {!likeLoading?( mode==='normal' ? <LikeCarousel data={happyData} /> : <LikeCarouselMini data={happyData} showCount={showCount} />):''}
    </React.Fragment>
  )
}
export default CarouselComponent;


